import * as Tone from "tone"
let inst = {};
let getRand = (arr) => arr[Math.floor(Math.random() * arr.length)]


let samples = [{
    'A2': 'scale-A2.[mp3|ogg]',
    'A3': 'scale-A3.[mp3|ogg]',
    'C3': 'scale-C3.[mp3|ogg]',
    'C4': 'scale-C4.[mp3|ogg]',
    'D3': 'scale-C3.[mp3|ogg]',
    'D4': 'scale-D4.[mp3|ogg]',
    'E3': 'scale-E3.[mp3|ogg]',
    'E4': 'scale-E4.[mp3|ogg]',
    'G2': 'scale-G2.[mp3|ogg]',
    'G3': 'scale-G3.[mp3|ogg]',
}, {
    'attack': 0.01,
    'release': 0.3,
    'baseUrl': './teropa/'
}]


let params = {
    "harmonicity":8,
    "modulationIndex": 2,
    "oscillator" : {
        "type": "sine"
    },
    "envelope": {
        "attack": 0.001,
        "decay": 2,
        "sustain": 0.1,
        "release": 2
    },
    "modulation" : {
        "type" : "square"
    },
    "modulationEnvelope" : {
        "attack": 0.002,
        "decay": 0.2,
        "sustain": 0,
        "release": 0.2
    }
}

let delayL = new Tone.PingPongDelay("4n", 0.0)
let delayR = new Tone.PingPongDelay("4n", 0.0)
let delay3 = new Tone.PingPongDelay("8n", 0.8)

delayL.wet.value = 0.0;
delayR.wet.value = 0.01;
delay3.wet.value = 0.2;
let meterL = new Tone.Meter();
let meterR = new Tone.Meter();
let defaultFreq = 20
let filterL = new Tone.Filter(defaultFreq, "highpass", -24);
let filterR = new Tone.Filter(defaultFreq, "highpass", -24);
let filter3 = new Tone.Filter(defaultFreq, "highpass", -24);

let pannerL1 = new Tone.Panner(-0.0).toDestination()
let pannerL2 = new Tone.Panner(-1.0).toDestination()
let pannerL3 = new Tone.Panner(-0.5).toDestination()
let pannerR1 = new Tone.Panner(0.9).toDestination()
let pannerR2 = new Tone.Panner(0.7).toDestination()
let pannerR3 = new Tone.Panner(0.6).toDestination()
let panner31 = new Tone.Panner(-0.2).toDestination()
let panner32 = new Tone.Panner(0).toDestination()
let panner33 = new Tone.Panner(0.2).toDestination()
// let synthL = new Tone.FMSynth(params)
// let synthR = new Tone.FMSynth(params)
let synthL = new Tone.Sampler(...samples)
let synthR = new Tone.Sampler(...samples)
let synth3 = new Tone.Sampler(...samples)
synthL.volume.value = -18
synthR.volume.value = -18
synth3.volume.value = -15
synthL.connect(delayL)
synthR.connect(delayR)
synth3.connect(delay3)

delayL.connect(filterL)
delayR.connect(filterR)
delay3.connect(filter3)
filterL.connect(pannerL1)
filterL.connect(pannerL2)
filterL.connect(pannerL3)
filterR.connect(pannerR1)
filterR.connect(pannerR2)
filterR.connect(pannerR3)
filter3.connect(panner31)
filter3.connect(panner32)
filter3.connect(panner33)

delayL.connect(meterL)
delayR.connect(meterR)

Tone.Transport.bpm.value = 60;

inst = {
    delayL,
    delayR,
    delay3,
    filterL,
    filterR,
    synthL,
    synthR,
    synth3,
    meterL,
    meterR,
    defaultFreq,
    ready: 0,
    drone: undefined,
    bell: undefined
}
export default inst
